export default {
  // 通用配置项
  common: {
    timer: 60, //默认接口请求间隔时间，0代表关闭定时器 单位:秒
  },
  // 自定义配置项, 分别定义以下组件的接口请求间隔时间
  custom: [
    {
      id: "list9927b1e0-ade8-4de4-8c56-ff6809182d83", //首页告警日志滚动列表组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list18e0b0b0-28dc-456a-a863-a5fb943abe7e", //首页车间养殖组件id
      timer: 300, //接口请求间隔时间，单位:秒
    },
    {
      id: "listc9397c69-8f0f-4463-8b1b-90345b6c28e5", //首页期数统计组件id
      timer: 300, //接口请求间隔时间，单位:秒
    },
    {
      id: "list980f74a5-fc45-4480-931b-9c6e7da68620", //首页期数阶段分布组件id
      timer: 300, //接口请求间隔时间，单位:秒
    },
    {
      id: "listefd9c5c3-c62d-4989-8847-a41490b0bbd6", //养殖期数天数趋势组件id
      timer: 300, //接口请求间隔时间，单位:秒
    },
    {
      id: "list33b9bcbe-2c8c-4886-8473-18e39a9fa116", //首页车间能耗组件id
      timer: 300, //接口请求间隔时间，单位:秒
    },
    {
      id: "list078b3dab-9360-400d-bc57-a320b4cd3d4c", //车间全景组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list6e6af543-62f7-4dd3-8dce-2a1f1d35ca2f", //设备管理组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "liste33ff793-0ebe-4cf3-9a28-d7ae15170e07", //运行监测组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "listfe8ae58b-29bd-4517-b0d4-8418645fd949", //一级蓄水池组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list93fec03a-62c8-4278-9a78-8fb97fba2072", //一级蓄水池水泵状态组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list15ac6c0f-15b7-4ed3-8338-4f67af195d0a", //一级蓄水池砂滤压力组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "lista9ff6f71-8d6f-45d0-bb76-0e09e3d97341", //车间二级蓄水池组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list0335608f-490f-4bb8-afb7-abf4cc17a675", //二级蓄水池进水泵详情组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "lista25e594a-498f-43c4-b259-aba86b353019", //二级蓄水池出水泵组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list0a7fbe38-43f7-4f01-83ab-f65fc28eaeed", //源水管道组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "listc0f33403-e943-4745-8163-da2b77c1e3f6", //二级管道组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list403d71fa-fb4b-4171-8f2c-cb3bed5980a6", //锅炉换热组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "lista9f73c88-33d4-4869-b042-ee3501ef284a", //新风监控组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list1224c639-5a3b-41f7-9a97-523294068e6f", //北区进水组件id
      timer: 5, //接口请求间隔时间，单位:秒
    },
    {
      id: "list6635703e-f947-4873-ad09-e60421432243", //设备树
      timer: 0, //关闭
    },
    {
      id: "listbb215b2d-a5b9-4d61-8bd0-8a5c79e980d8", //养虾单元
      timer: 5, //接口请求间隔时间，单位:秒
    },
  ],
  // 告警铃声配置项
  alarm: {
    checkAlarmTimer: 0, //定时器：间隔5秒检查一次是否有告警日志，用于告警铃声和告警列表
    audioPlayTime: 60, //告警铃声播放时长，到达时长后停止播放,单位:秒
    waitAudioTime: 300, //告警铃声停止播放等待时长，到达时长后重新播放铃声，单位:秒
    closeTime:5
  },
  versionUpdate: {
    updateTime: 1800, //定时器：间隔30分钟检查一次是否有版本更新
  },
  // 故障看板
  fault: {
    checkFaultTimer: 60,
  },
  // 任务看板
  task: {
    checkTaskTimer: 60,
  },
};
